import { render, staticRenderFns } from "./StatistiquesQI.vue?vue&type=template&id=5cf2f642&"
import script from "./StatistiquesQI.vue?vue&type=script&lang=js&"
export * from "./StatistiquesQI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports